<progress-bar-component></progress-bar-component>

<loader-full-fragment></loader-full-fragment>

<router-outlet></router-outlet>
